import useSWR from 'swr';
import { fetcher } from '@shared/fetcher';
import { BannerSchema, IBanner } from '@shared/types.ts';

async function fetchBanners(url: string) {
  const res = await fetcher.get<{ data: IBanner[] }>(url).catch(() => null);
  if (!res) return undefined;
  return res.data?.data.filter((i) => BannerSchema.isValidSync(i));
}

export function useBanners() {
  const { data, isLoading } = useSWR('/api/banners', fetchBanners, {
    suspense: true,
  });

  const array = Array(10).fill(0);

  return {
    data: data || [],
    array,
    isLoading,
    isPreloader: typeof data === 'undefined',
  };
}
